export const titleWithoutPipe = title => {
  return title.split("| ")[1]
}
